import _classCallCheck from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { TokenType as tt } from "../parser/tokenizer/types";
import Transformer from "./Transformer";

var OptionalCatchBindingTransformer = /*#__PURE__*/function (_Transformer) {
  _inherits(OptionalCatchBindingTransformer, _Transformer);

  var _super = _createSuper(OptionalCatchBindingTransformer);

  function OptionalCatchBindingTransformer(tokens, nameManager) {
    var _this;

    _classCallCheck(this, OptionalCatchBindingTransformer);

    _this = _super.call(this);
    _this.tokens = tokens;
    _this.nameManager = nameManager;
    ;
    return _this;
  }

  _createClass(OptionalCatchBindingTransformer, [{
    key: "process",
    value: function process() {
      if (this.tokens.matches2(tt._catch, tt.braceL)) {
        this.tokens.copyToken();
        this.tokens.appendCode(" (".concat(this.nameManager.claimFreeName("e"), ")"));
        return true;
      }

      return false;
    }
  }]);

  return OptionalCatchBindingTransformer;
}(Transformer);

export { OptionalCatchBindingTransformer as default };